import React, {useEffect, useState} from 'react';
import Notification from '../Notification';
import LanguageSelector from '../LanguageSelector';
import './index.scss';
import {useLocation, useNavigate, useParams} from 'react-router-dom';
import { useTranslation } from '../../hooks/useTranslation';
import {
  useLazyGetFacilityQuery,
  useLazyRefreshInspectionsQuery,
} from '../../store/builder/inspections.api';
import {useErrorHandler} from '../../global/ErrorsHandler';
import {useDispatch, useSelector} from 'react-redux';
import {setLoader} from '../../store/builder/reducer';
import useLoader from '../../global/UseLoadingHandler';
import NotificationIcon from '../../SVG/NotificationIcon';

export default function Dashboardheader__top({
  title,
  showBtn = true,
  type = '',
  action,
  inspection_type = '',
  secondAction,
  dataForSecondAction,
  facilityId,
  cancelNav = -1,
  custom_inspection_name = '',
  bottomElement,
  fixedOnTop,
}) {
  const { t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);

  const [
    refreshInspectionAction,
    {error: refreshError, isFetching: refreshIsLoading},
  ] = useLazyRefreshInspectionsQuery();

  const [
    getFacility,
    {
      data: facilityData,
      isError: facilityIsError,
      isFetching: facilityIsLoading,
      error: facilityError,
      isSuccess: facilityIsSuccess,
    },
  ] = useLazyGetFacilityQuery();

  const [errorHandler, setErrorHandler] = useErrorHandler([
    refreshError,
    facilityError,
  ]);

  useLoader([refreshIsLoading]);

  useEffect(() => {
    getFacility();
  }, []);

  function formatString(inputString) {
    return inputString.replace(/[_\W]+/g, ' ');
  }

  return (
    <div className='header'>
      <div
        className='header__top'
        style={!bottomElement ? {marginBottom: '26px'} : {}}
      >
        {type === 'inspection_form_update' ? (
          <div>
            <div className='header__top__subtitle'>
              {type === 'inspection_form_update'
                ? title
                : formatString(inspection_type) + ' Inspection'}
            </div>
            <div className='header__top__title_i'>
              {type === 'inspection_form_update' ? t('components.categories') : title}
            </div>
          </div>
        ) : type === 'custom-inspections-forms' ? (
          <div>
            <div className='header__top__subtitle'>{t('components.inspectionForms')}</div>
            <div className='header__top__title_i'>{custom_inspection_name}</div>
          </div>
        ) : (
          <p className='header__top__title'>{title}</p>
        )}
        <div className='header__top__right'>
        {showBtn && (
          <>
            {type === 'inspection-form' ? (
              showBtn && (
                <div className='header__top__btn' onClick={action}>
                  {t('components.createInspect')}
                </div>
              )
            ) : type === 'build-form' ? (
              <div className='header__top__btn white' onClick={action}>
                {t('components.cancel')}
              </div>
            ) :

            type === 'receiptForm' ? (
              <div className='header__top__btn' onClick={action}>
                {t('components.createReport')}
              </div>
            ) : type === 'logSheets' ? (
              showBtn && (
                <div className='header__top__btn' onClick={action}>
                  <span>{t('components.clearInspections')}</span>
                </div>
              )
            ) : type === 'serviceRequest' ? (
              <div className='header__top__btn' onClick={action}>
                {t('components.createObservation')}
              </div>
            ) : type === 'inspection' ? (
              <>
                {import.meta.env.VITE_ENVIRONMENT !== 'production' ? (
                  <div
                    className='header__top__btn'
                    onClick={() => {
                      refreshInspectionAction().then(res => {
                        secondAction(facilityId);
                      });
                    }}
                  >
                    {t('components.refreshInspections')}
                  </div>
                ) : userInfo.role.name === 'global' &&
                  import.meta.env.VITE_ENVIRONMENT == 'production' ? (
                  <div
                    className='header__top__btn'
                    onClick={() => {
                      refreshInspectionAction().then(res => {
                        secondAction(facilityId);
                      });
                    }}
                  >
                    {t('components.refreshInspections')}
                  </div>
                ) : null}
                <div className='header__top__btn plus' onClick={action}>
                  <img src='/assets/icons/inspection-plus.svg' alt='plus' />
                </div>
              </>
            ) : type === 'equipment' ? (
              <div className='header__top__btn' onClick={action}>
                {t('components.createEquipment')}
              </div>
            ) : type === 'tools' ? (
              <div className='header__top__btn' onClick={action}>
                {t('components.createTool')}
              </div>
            ) : type === 'facility-edit' ? (
              <div className='header__top__btns'>
                <div
                  className='header__top__btn cancel'
                  onClick={() => navigate(-1)}
                >
                  {t('components.cancel')}
                </div>
                <div className='header__top__btn' onClick={action}>
                  {t('components.save')}
                </div>
              </div>
            ) : type === 'management' ? (
              <div className='header__top__btn' onClick={action}>
                {t('components.inviteUser')}
              </div>
            ) : type === 'facility' ? (
              <div className='header__top__btn' onClick={action}>
                {t('components.createFacility')}
              </div>
            ) :
            type === 'order' ? (
              <div className='header__top__btn' onClick={action}>
                {t('components.createManualOrder')}
              </div>
            ) : type === 'report' ? (
              <div className='header__top__btn' onClick={action}>
                {t('components.createReport')}
              </div>
            ) : type === 'equipment-edit' ? (
              <div className='header__top__btns'>
                <div
                  className='header__top__btn cancel'
                  onClick={() => navigate(-1)}
                >
                  {t('components.cancel')}
                </div>
                <div className='header__top__btn' onClick={action}>
                  {t('components.save')}
                </div>
              </div>
            ) : type === 'equipment-type' ? (
              <div className='header__top__btn' onClick={action}>
                {t('components.assignedInspections')}
              </div>
            ) : type === 'assigned' ? (
              <div
                className='header__top__btn cancel'
                onClick={() => navigate(-1)}
              >
                {t('components.cancel')}
              </div>
            ) : type === 'dashboard' ? (
              <div className='header__top__btn green' onClick={action}>
                <img src='/assets/icons/bar-chart-icon.svg' alt='icon' />
                {t('components.advancedMetrics')}
              </div>
            ) : type === 'agancy-trial' ? (
              <div className='header__top__btns'>
                <div className='header__top__btn invite' onClick={action}>
                  {t('components.inviteFbo')}
                </div>
                <div className='header__top__btn' onClick={secondAction}>
                  {t('components.createFbo')}
                </div>
              </div>
            ) : type === 'agancy-invited' ? (
              <div className='header__top__btns'>
                <div className='header__top__btn' onClick={action}>
                  {t('components.inviteFbo')}
                </div>
              </div>
            ) : type === 'invite-corporate' ? (
              <div className='header__top__btns'>
                <div className='header__top__btn invite' onClick={action}>
                  {t('components.inviteCorporate')}
                </div>
              </div>
            ) : type === 'fbo-management' ? (
              <div className='header__top__btns'>
                <div className='header__top__btn' onClick={action}>
                  {t('components.createFbo')}
                </div>
              </div>
            ) : type === 'corporate' ? (
              <div className='header__top__btns'>
                <div className='header__top__btn grey' onClick={action}>
                  {t('components.createCorporate')}
                </div>
                <div className='header__top__btn' onClick={secondAction}>
                  {t('components.inviteCorporate')}
                </div>
              </div>
            ) : type === 'corporate-details-regions' ? (
              <div className='header__top__btns'>
                <div className='header__top__btn' onClick={action}>
                  {t('components.createRegion')}
                </div>
              </div>
            ) : type === 'corporate-details-invite' ? (
              <div className='header__top__btns'>
                <div className='header__top__btn' onClick={action}>
                  {t('components.inviteUser')}
                </div>
              </div>
            ) : type === 'forms' ? (
              <div className='header__top__btns'>
                <div className='header__top__btn' onClick={action}>
                  {t('components.createForm')}
                </div>
              </div>
            ) : type === 'custom-inspections' ? (
              <div className='header__top__btns'>
                <div className='header__top__btn' onClick={action}>
                  {t('components.buildInspection')}
                </div>
              </div>
            ) : type === 'custom-inspections-forms' ? (
              <div className='header__top__btns'>
                <div className='header__top__btn' onClick={action}>
                  {t('components.modifyInspection')}
                </div>
              </div>
            ) :
            action}
            </>
          )}
          <div className='header__top__notification'>
            <Notification />
          </div>
        </div>
      </div>
      {bottomElement && <div className='header__bottom'>{bottomElement}</div>}
    </div>
  );
}
